import {random_decimal, random_integer} from './random.js';
import {px_to_em} from './conversions.js';

export function slope(r) {
  if (r >= 0 && r <= 90) {
    return {x:r/90, y:-1+r/90};
  }
  if (r > 90 && r <= 180) {
    return {x:1-(r-90)/90, y:(r-90)/90};
  }
  if (r > 180 && r <= 270) {
    return {x:-(r-180)/90, y:1-(r-180)/90};
  }
  if (r > 270 && r <= 360) {
    return {x:-1+(r-270)/90, y:-(r-270)/90};
  }
}

export function orient(quadrant, width, height) {
  if (quadrant <= 0.25) {
    return {
      x : px_to_em(-250),
      y : px_to_em(random_integer(0, height)),
      r : random_integer(0, 180)
    };
  }
  if (quadrant <= 0.50) {
    return {
      x : px_to_em(random_integer(0, width)),
      y : px_to_em(-250),
      r : random_integer(90, 270)
    };
  }
  if (quadrant <= 0.75) {
    return {
      x : px_to_em(width+250),
      y : px_to_em(random_integer(0, height)),
      r : random_integer(180, 360)
    };
  }
  if (quadrant <= 1.0) {
    return {
      x : px_to_em(random_integer(0, width)),
      y : px_to_em(height+250),
      r : random_decimal() > 0.5 ? random_integer(270, 360) : random_integer(0, 90)
    };
  }
}